import { render, staticRenderFns } from "./fiveGrids.vue?vue&type=template&id=fcab98c8&scoped=true&"
import script from "./fiveGrids.vue?vue&type=script&lang=js&"
export * from "./fiveGrids.vue?vue&type=script&lang=js&"
import style0 from "./fiveGrids.vue?vue&type=style&index=0&id=fcab98c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab98c8",
  null
  
)

export default component.exports